<div class="consultant-rates-page">

  <!-- Selected Client / Selected Project -->
  <app-project-header-card></app-project-header-card>

  <!-- Consultant Project Rates Form -->
  <div class="formSection">

    <div class="section-title">
      Consultant Project Rates
    </div>

    <form [formGroup]="ratesForm">

      <!-- Four fields in one straight row -->
      <div class="rate-fields">

        <!-- Month -->
        <div
          class="rate-field select-field"
          [class.has-value]="ratesForm.get('month')?.value"
        >
          <label>
            Select a month <span class="required">*</span>
          </label>

          <ng-select
            [items]="monthsList"
            formControlName="month"
            [clearable]="false">
          </ng-select>
        </div>

        <!-- Consultant -->
        <div
          class="rate-field select-field"
          [class.has-value]="ratesForm.get('consultant')?.value"
        >
          <label>
            Select a consultant <span class="required">*</span>
          </label>

          <ng-select
            [items]="consultantsList"
            formControlName="consultant"
            [clearable]="false">
          </ng-select>
        </div>

        <!-- Hourly Rate -->
        <div class="rate-field input-field-wrapper">
          <label>
            Hourly Rate <span class="required">*</span>
          </label>

          <input
            type="number"
            formControlName="hourlyRate"
            min="0"
            class="rate-input"
          />
          <div
            class="validation-error"
            *ngIf="ratesForm.get('hourlyRate')?.hasError('min')
                  && ratesForm.get('hourlyRate')?.touched"
          >
            Hourly Rate can't be negative.
          </div>
        </div>

        <!-- Leverage -->
        <div class="rate-field input-field-wrapper">
          <label>
            Leverage <span class="required">*</span>
          </label>

          <input
            type="number"
            formControlName="leverage"
            min="0"
            class="rate-input"
          />
          <div
            class="validation-error"
            *ngIf="ratesForm.get('leverage')?.hasError('min')
                  && ratesForm.get('leverage')?.touched"
          >
            Leverage can't be negative.
          </div>
        </div>


      </div>

      <!-- Buttons -->
      <div class="rate-actions">

        <!-- Left -->
        <button
          mat-raised-button
          type="button"
          [disabled]="ratesForm.invalid"
          class="submit-button action-button"
          (click)="onSubmitRate()"
        >
          <mat-icon>add</mat-icon>
          <span>Submit</span>
        </button>

        <!-- Right -->
        <div class="right-actions">

          <button
            mat-raised-button
            type="button"
            [disabled]="!isSaveEnabled"
            class="save-button action-button"
            (click)="onSaveRates()"
          >
            <mat-icon>save</mat-icon>
            <span>Save</span>
          </button>

          <button
            mat-raised-button
            type="button"
            [disabled]="!isDeleteEnabled"
            class="delete-button action-button"
            (click)="onDeleteRates()"
          >
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>

          <button
            mat-raised-button
            type="button"
            class="submit-button action-button"
            (click)="onNextTab()"
          >
            <mat-icon>skip_next</mat-icon>
            <span>Next</span>
          </button>

        </div>

      </div>

    </form>
  </div>

  <!-- AG Grid -->
  <div class="rates-grid">
    <ag-grid-angular
      class="ag-theme-balham"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [suppressRowClickSelection]="true"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (cellEditingStarted)="onCellEditingStarted($event)"
      (cellEditingStopped)="onCellEditingStopped($event)"
    >
    </ag-grid-angular>
  </div>

</div>